<template>
  <div class="page-wrapper">
    <search-list class="mb16"
                @getdata="getData"
    ></search-list>
    <Button class="mb16"
            type="primary"
            @click.stop="downLoadFollowInTimeRateList"
            :loading="buttonloading"
            v-p="{menu:'followintime',api:'report/downLoadFollowInTimeRateList'}"
    >导出</Button>
    <table-list
      title="" :columns="columns" :data="data"
      :loading="loading"
      :total="total"
      :current="current"
      @change-page="changePage"
      class = "report"
    ></table-list>
  </div>
</template>

<script>
  import SearchList from '../components/SearchList'
  import TableList from "components/TableList/index";
  import {followInTimeRate} from "../../../api/reporter";
  import {getProjects} from "../../../api/common";
  import {formatDateTime} from "../../../utils/format";
  import subTable from './components/SubTable'
  import {downLoadFollowInTimeRateList} from "../../../api/reporter";

  export default {
    name: "followintime",
    components:{
      SearchList,
      TableList,
      subTable
    },
    data(){
      return {
        searchData: null,
        columns: [
          {
            width:50,
            type: 'expand',
            title:' ',
            render:(h,params)=>{
              return h(subTable,{
                props:{
                  columns:this.columns,
                  params:{
                    "endTime": this.searchData.endTime,
                    "projectFids": [
                      params.row.projectFid
                    ],
                    "startTime": this.searchData.startTime,
                    "type": this.searchData.type
                  },
                }

              })
            }
          },
          {
            title:'项目名称',
            key:'projectName',
            align: 'center',
            width:170
          },
          {title:' '},
          {
            title:'UV',
            key:'uv',
            align: 'center',
            width:100
          },
          {title:' '},
          {
            title:'商机量',
            key:'businessNum',
            align: 'center',
            width:100
          },
          {title:' '},
          {
            title:'及时跟进率',
            key:'flowInTimeRate',
            align: 'center',
            width:100
          },
          {title:' '},
          {
            title:'商机转带看',
            key:'businessToLook',
            align: 'center',
            width:100
          },
          {title:' '},
          {
            title:'转化率',
            key:'businessToLookRate',
            align: 'center',
            width:100
          },
          {title:' '},
          {
            title:'带看转成交',
            key:'businessToDone',
            align: 'center',
            width:100
          },
          {title:' '},
          {
            title:'转化率',
            key:'businessToDoneRate',
            align: 'center',
            width:100
          },

          // {
          //   title:'带看转签约',
          //   key:'',
          //   align: 'center',
          // },
          // {
          //   title:'转化率',
          //   key:'',
          //   align: 'center',
          // },
        ],
        page:1,
        current: 1,
        total: 0,
        data: [],
        loading: false,
        buttonloading:false

      }
    },
    methods:{
      downLoadFollowInTimeRateList(){
        if(!this.searchData){
          return
        }
        this.buttonloading=true;
        downLoadFollowInTimeRateList(this.searchData).then(res=>{
          let fileName = res.headers.filename || 'excel.xls';
          let blob = new Blob([res.data]);

          let url = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          this.buttonloading=false

        }).catch(error=>{}).finally(()=>{
          this.buttonloading=false
        })

      },
      init() {
        let ret = {
          projectFids: [],
          type: 0,
          startTime: '',
          endTime: '',
          page: 1,
          limit: 10
        };
        let p1 = getProjects().then(res => {
          if (!res.data) {
            return
          }
          res.data.length > 0 && (ret.projectFids = [res.data[0].value])
        }).catch(error => {
        }).finally(() => {
          let date = new Date();
          let year = date.getFullYear();
          let month = date.getMonth();
          let day = date.getDate();
          ret.startTime = formatDateTime(new Date(year, month, day - 7), false);
          ret.endTime = formatDateTime(new Date(year, month, day - 1), false);
          this.searchData = ret;
          this.followInTimeRate()

        })
      },
      followInTimeRate(){
        let params={
          ...this.searchData,
          page:this.page,
          limit:10
        };
        followInTimeRate(params).then(res=>{
          if(!res.data){
            return
          }
          res.data.list.forEach((ele)=>{
            if(!ele.projectFid){
              ele['_disableExpand']=true
            }
          });
          this.data=res.data.list;
          this.total=res.data.total
        })
      },
      getData(params){
        this.current=1;
        this.page=1;
        this.searchData=params;
        this.followInTimeRate()
      },
      changePage(n){
        this.current = n;
        this.page = n;
        this.followInTimeRate()
      }
    },
    created(){
      // this.init()
    }
  }
</script>

<style scoped>

</style>
